<template>
    <VAppLayout>
        <VContainer>
            <div class="cart-header">
                <div class="cart-header-content">
                    <h3>
                        {{ `${$t('pages.cart.total')}: ${comFormTotalPrice}` }}
                    </h3>
                    <span>
                        {{ $t('pages.cart.step') }} 2
                    </span>
                </div>
                <div class="cart-header-logo">
                    <img :src="comLocale.logo"
                         :alt="`Logo of ${comLocale.name}`">
                </div>
            </div>
            <div class="cart-client-info">
                <h6>
                    {{ $t('pages.cart.enterYourDetails') }}:
                </h6>
                <input type="text" v-if="!isSelfPickup" v-model="clientName" :placeholder="`${$t('pages.cart.fullName')} *`" required>
              <VuePhoneNumberInput v-if="isSelfPickup"
                                   v-model="tempPhone"
                                   default-country-code="PL"
                                   @update="updatePhone"
                                   :no-example="true"
                                   :preferred-countries="['PL', 'DE', 'ES', 'FR', 'UA', 'US']"
                                   :translations="getPhoneInputTranslations()"
                                   :border-radius="12"
                                   color="#7019FD"
                                   required />
                <div v-if="!isSelfPickup">
                    <v-select v-model="clientRoom"
                        :options="roomList"
                        label="name"
                        :placeholder="`${$t('pages.cart.selectRoomNumber')} *`"
                        required>
                        <!-- <template #option="{ name }">
                        <div style="display: flex; align-items: baseline">
                            <strong>{{ name }}</strong>
                            <span class="checkmark">✔</span>
                        </div>
                    </template> -->
                    </v-select>
                    <span class="cart-client-room-info">
                        <IconBase width="14"
                                  height="14"
                                  viewBox="0 0 14 14">
                            <IconInfo />
                        </IconBase>
                        {{ $t('pages.cart.checkRoomNumber') }}
                    </span>
                </div>

                <input type="text"
                       v-model="clientMessage"
                       :placeholder="$t('pages.cart.orderComment')">
            </div>
            <div class="cart-payment-method">
                <h6>
                    {{ $t('pages.cart.selectPaymentMethod') }}:
                </h6>
                <RadioButton v-if="comPaymentMethods.cash"
                             inputValue="cash"
                             :label="$t('pages.cart.cash')"
                             v-model="paymentMethod" />
                <RadioButton v-if="comPaymentMethods.card && isPaymentAdded"
                             inputValue="card"
                             :label="$t('pages.cart.paymentCard')"
                             v-model="paymentMethod" />
                <RadioButton v-if="comPaymentMethods.room"
                             inputValue="room"
                             :label="$t('pages.cart.chargeRoom')"
                             v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.cash_on_delivery"
                           inputValue="cash_on_delivery"
                           :label="$t('pages.cart.cashDelivery')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.card_on_delivery"
                           inputValue="card_on_delivery"
                           :label="$t('pages.cart.cardDelivery')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.cash_on_pickup"
                           inputValue="cash_on_pickup"
                           :label="$t('pages.cart.cashPickup')"
                           v-model="paymentMethod" />
              <RadioButton v-if="comPaymentMethods.card_on_pickup"
                           inputValue="card_on_pickup"
                           :label="$t('pages.cart.cardPickup')"
                           v-model="paymentMethod" />

            </div>
            <div class="cart-vat">
                <CheckboxButton :label="$t('pages.cart.vatRulesTitle')"
                                v-model="vatRulesAccepted" />
                <p class="cart-vat-error"
                   v-if="vatRulesAccepted">{{ $t('pages.cart.vatRulesDescriptionHotel') }}</p>
            </div>


            <VButton type="dark-violet"
                     height="short"
                     v-on:click.native="handlePayment()">
                {{ $t('pages.cart.orderAndPay') }}
            </VButton>
        </VContainer>
    </VAppLayout>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import VAppLayout from "@/layouts/VAppLayout.vue";
import VButton from "@/components/ui/VButton.vue";
import VContainer from "@/components/ui/VContainer.vue";
import RadioButton from '@/components/RadioButton.vue';
import CheckboxButton from '@/components/CheckboxButton.vue';
import IconBase from '@/components/IconBase.vue';
import IconInfo from '@/components/icons/IconInfo.vue';


export default {
    name: "CartTab",
    props: ['orderId'],
    components: {
        VuePhoneNumberInput,
        vSelect,
        VContainer,
        VButton,
        VAppLayout,
        RadioButton,
        CheckboxButton,
        IconBase,
        IconInfo,
    },
    data() {
        return {
            clientName: '',
            clientMessage: '',
            formattedPhone: '',
            tempPhone: '',
            vatRulesAccepted: false,
        };
    },
    mounted() {
        if (!this.paymentMethod) {
            this.paymentMethod = Object.keys(this.comPaymentMethods).find(key => this.comPaymentMethods[key] === 1);
        }
    },
    methods: {
        handlePayment() {
            if (!this.areFieldsFilled()) {
                return;
            }
            const phone = this.formattedPhone.e164;
            this.$store.dispatch('cartStore/SET_CLIENT_PHONE', phone);

            this.$store.dispatch('cartStore/MAKE_A_PAYMENT', { comment: this.clientMessage, personalInfo: this.clientName });
        },
        areFieldsFilled() {
            const nameValid = !!this.clientName || this.isSelfPickup;
            const phoneValid = !this.isSelfPickup || this.formattedPhone.isValid;
            const roomValid = !!this.clientRoom || this.isSelfPickup;

            if (nameValid && phoneValid && roomValid) {
                return true;
            }

            let errorMessage = '';

            if (!nameValid) {
                errorMessage += this.$t('pages.cart.invalidFullName') + '\n';
            }
            if (!phoneValid) {
                errorMessage += this.$t('pages.cart.invalidPhone') + '\n';
            }
            if (!roomValid) {
                errorMessage += this.$t('pages.cart.invalidRoomNumber') + '\n';
            }

            this.$toast.error(errorMessage, { position: 'top-center' });
            return false;
        },
        getPhoneInputTranslations() {
            return {
                countrySelectorLabel: this.$t('pages.cart.countrySelectorLabel'),
                countrySelectorError: this.$t('pages.cart.countrySelectorError'),
                phoneNumberLabel: this.$t('pages.cart.phoneNumberLabel')
            };
        },
        updatePhone(value) {
            this.formattedPhone = value;
        },
    },
    computed: {
        comCompanyData() {
            return this.$store.getters['getCompanyData'];
        },
        comLocale() {
            return this.comCompanyData.locale;
        },
        comFormTotalPrice() {
            return this.$store.getters['cartStore/getFormattedCartTotal'];
        },
        isSelfPickup() {
            return this.$store.getters['cartStore/getDeliveryMethod'] && this.$store.getters['cartStore/getDeliveryMethod'].self_pickup === 1;
        },
        comPaymentMethods() {
            return this.$store.getters['cartStore/getDeliveryMethod'].payment_methods ? this.$store.getters['cartStore/getDeliveryMethod'].payment_methods : this.$store.getters['getPaymentMethods'];
        },
        paymentMethod: {
            get() {
                return this.$store.getters['cartStore/getPaymentMethod'];
            },
            set(val) {
                this.$store.dispatch('cartStore/SET_PAYMENT_METHOD', val);
            }
        },
        roomList() {
            return this.comLocale.available_tables.filter(t => t.name);
        },
        clientRoom: {
            get() {
                return this.$store.getters['getTableData'];
            },
            set(val) {
                this.$store.commit('SET_TABLE_DATA', val);
            }
        },
        isPaymentAdded() {
            return this.comLocale.activePaymentCredentials === 1;
        }
    },
};
</script>

<style lang="scss" scoped>
@import "src/scss/assets/variables";

.v-container {
    display: flex;
    flex-direction: column;
    gap: 14px;

    > :last-child {
        margin-bottom: 24px;
    }

    color: black
}


h6 {
    font-size: 14px;
    margin: 0;
    padding: 0;
}


.cart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    &-content {
        position: relative;

        margin: 12px 0;

        &>h3 {
            font-size: 24px;
            font-weight: 700;
            margin: 20px 0;
            padding: 0;
        }

        &>span {
            position: absolute;
            bottom: 0;

            font: {
                size: 14px;
                weight: 500;
            }

            color: #929292;

            &:is(.hidden) {
                visibility: hidden;
            }
        }
    }

    &-logo {
        width: 66px;
        height: 66px;
        overflow: hidden;
        flex-shrink: 0;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
}

.cart-client-info {
    display: flex;
    flex-direction: column;
    gap: 14px;

    margin-bottom: 32px;

    >input {
        height: 40px;

        padding: 0 12px;

        font-weight: 400;
        font-size: 12px;

        border: 2px solid #E6E6E6;
        box-shadow: 2px 2px 10px 0px #0000000A;
        border-radius: 12px;

        &:hover,
        &:focus {
            border-color: $color_violet_electric;
            transition-duration: .3s;
        }
    }

    .vue-phone-number-input {
        z-index: 2;

        ::v-deep {
            .input-tel__input {
                border: 2px solid #E6E6E6;
                box-shadow: 2px 2px 10px 0px #0000000A;

                &:focus {
                    box-shadow: 0 0 0 0 !important;
                }

                &::placeholder {
                    font-weight: 400;
                    font-size: 12px;

                    color: $color_grey_oslo;
                }
            }

            .country-selector__label {
                font-weight: 400;

                color: $color_grey_oslo;
            }

            .country-selector__input {
                border: 2px solid #E6E6E6;
                box-shadow: 2px 2px 10px 0px #0000000A;

                &:focus {
                    box-shadow: 0 0 0 0 !important;
                }
            }
        }
    }

    .v-select {
        margin-bottom: 5px;

        font-weight: 400;
        font-size: 12px;

        color: $color_grey_oslo;

        --vs-border-radius: 12px;
        --vs-font-size: 12px;
        --vs-search-input-color: #{$color_grey_oslo};
        --vs-dropdown-option--active-bg: #D7D8FF;
        --vs-dropdown-option--active-color: black;
        --vs-dropdown-color: black;

        ::v-deep {
            .vs__search {
                height: 40px;

                padding: 0 12px;
                margin: 0;
            }

            .vs__clear {
                width: auto;
            }

            .vs__dropdown-toggle {
                padding-bottom: 0;

                border: 2px solid #E6E6E6;
                box-shadow: 2px 2px 10px 0px #0000000A;

                &:hover {
                    border-color: $color_violet_electric;
                    transition-duration: .3s;
                }
            }

            .vs__dropdown-menu {
                font-size: 14px;
                font-weight: 500;
                line-height: 22px;
            }
        }

        &.vs--open ::v-deep {
            .vs__selected {
                position: relative;
            }

            .vs__dropdown-toggle {
                border-color: $color_violet_electric;
                border-bottom: 0;
                transition-duration: .3s;
            }
        }
    }

    .cart-client-room-info {
        display: flex;
        align-items: center;
        gap: 5px;

        font-weight: 400;
        font-size: 12px;

        color: $color_violet_electric;
    }
}

.cart-payment-method {
    display: grid;
    gap: 14px;
}

.cart-vat {
    margin-top: auto;

    &-error {
        padding: 10px;
        color: red;
        border: 1px solid #FF3737;
        background: #FFDBDB36;
        border-radius: 13px;
        margin: 5px 0px 0px;
    }
}
</style>
